exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.svg-icon[data-v-50bb3a14] {\n  width: 1.2em;\n  height: 1.2em;\n  vertical-align: -0.18em;\n  fill: currentColor;\n  overflow: hidden;\n}\n", "", {"version":3,"sources":["/var/jenkins_home/workspace/pro-maibenben-mall-admin-front/src/components/SvgIcon/index.vue"],"names":[],"mappings":";AACA;EACE,aAAa;EACb,cAAc;EACd,wBAAwB;EACxB,mBAAmB;EACnB,iBAAiB;CAClB","file":"index.vue","sourcesContent":["\n.svg-icon[data-v-50bb3a14] {\n  width: 1.2em;\n  height: 1.2em;\n  vertical-align: -0.18em;\n  fill: currentColor;\n  overflow: hidden;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-50bb3a14","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/SvgIcon/index.vue
// module id = P5wA
// module chunks = 65